import * as React from "react";
import { useRef } from "react";
import { Button, Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
// import { read } from "fs";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { toast } from "react-toastify";
import { IAddAssetType, IAddCommonAreaSubType } from "../../../Common/Contracts/IFacilities";
import { EntityManagementService } from "../../../Common/Services/EntityManagementService";
import { Facility } from "../../../Common/Services/Facility";
import { Utils } from "../../../Common/Utilis";
import OutsideClickHandler from "react-outside-click-handler";
import { confirmAlert } from "react-confirm-alert";

export const DropDownList: React.FC<any> = (props: any) => {
  const inputElement: any = React.createRef();
  const toggleRef: any = React.createRef();

  const [placeHolder, setPlaceholder] = React.useState(props?.placeHolder);
  const [selectedItem, setSelectedItem] = React.useState(props?.selectedItem || {});
  const [data, setData] = React.useState(props?.data || []);
  const [filterData, setFilterData] = React.useState(props?.data || []);
  const [disabled, setdisabled] = React.useState(props?.disabled);
  const [inputValue, setInputValue] = React.useState("");
  const [addSubtypeDropdown, setAddSubtypeDropdown] = React.useState(false);
  const [newSubType, setnewSubType] = React.useState("");
  const [userClickPosition, setUserClickPosition] = React.useState(0)
  const dropdownMenuRef = React.createRef<HTMLDivElement>();
  const [updateSubtypeDropdown, setUpdteSubtypeDropdown] = React.useState(0)
  const [editDropdown, setEditDropdown] = React.useState(0)
  const [updatedAssetName, setUpdatedAssetName] = React.useState('')
  // const [refreshKey, setRefreshKey] = React.useState(0);

  //When dropdown data values changed depending on another dropdown
  React.useEffect(() => {
    setData(props?.data || [])
    setFilterData(props?.data || [])
    setSelectedItem(props?.selectedItem || {})
  }, [props.data, props.dependent])

  // React.useEffect(()=>{
  //   setData(props?.data || [])
  //   setFilterData(props?.data || [])
  //   setSelectedItem(props?.selectedItem || {})
  //   console.log('called refresh')
  // }, [refreshKey])


  React.useEffect(() => {
    const { defaultValue, value, label, shouldToggle } = props;
    if (!selectedItem && props?.selectedItem) {
      handleDropdownChange(props?.selectedItem);
    }
    else if (selectedItem) {
      if (
        defaultValue &&
        selectedItem[value] !== defaultValue &&
        data.length > 0
      ) {
        const selectedItem = data?.find((r) => r[value] === defaultValue);
        handleDropdownChange(selectedItem);
      }
    } else {
      if (data?.length > 0 && defaultValue) {
        const selectedItem = data?.find((r) => r[value] === defaultValue);
        handleDropdownChange(selectedItem);
      }
    }


  });

  // const forceRefreshFromChild = () => {
  //   console.log("Refresh triggered from child");
  //   setRefreshKey((prevKey) => prevKey + 1);
  // };
  // console.log("refreshKey", refreshKey)

  // const showDropdown = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   const tripleDotElement = e.target;
  //   const dropdownMenuElement = dropdownMenuRef.current;

  //   // Calculate position relative to the dropdown menu's scroll position
  //   const elementRect = tripleDotElement.getBoundingClientRect();
  //   const menuRect = dropdownMenuElement.getBoundingClientRect();
  //   const offsetValue = elementRect.top - menuRect.top + dropdownMenuElement.scrollTop;
  //   const offsetTop = e.target.offsetTop;
  //   setUserClickPosition(offsetValue)
  // }

  const showDropdown = (e: React.MouseEvent<HTMLButtonElement>, id, item) => {
    console.log("items", item)
    e.preventDefault();
    e.stopPropagation();

    const tripleDotElement = e.target as HTMLElement;
    const dropdownMenuElement = dropdownMenuRef.current;

    if (dropdownMenuElement) {
      const elementRect = tripleDotElement.getBoundingClientRect();
      const menuRect = dropdownMenuElement.getBoundingClientRect();
      const offsetValue = elementRect.top - menuRect.top + dropdownMenuElement.scrollTop;
      const viewportHeight = window.innerHeight;
      const dropdownHeight = dropdownMenuElement.offsetHeight;

      let topPosition = offsetValue;
      if (topPosition + dropdownHeight > viewportHeight) {
        topPosition = viewportHeight - dropdownHeight - 10;
      }
      setUserClickPosition(topPosition);
      setEditDropdown(id)
    } else {
      console.warn("Dropdown menu element is not available.");
    }
  };

  const handleRename = (id: number) => {
    const assetName = filterData.find(
      (item: { assetTypeId: number }) => item.assetTypeId === id
    );
    setUpdteSubtypeDropdown(id)
    setUpdatedAssetName(assetName ? assetName.assetTypeName : '')
    setInputValue('')
    setEditDropdown(0)
  };

  const handleDropdownSearch = (e: { target: { value: string } }) => {
    const { label } = props;
    const updatedList = data.filter(
      (item) =>
        item[label]
          ?.toString()
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) > -1
    );
    setFilterData(updatedList);
    setInputValue(e.target.value);
  };

  const hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };
  const handleDropdownChange = (item: any) => {

    if (!item || (item[props?.value] === undefined || item[props?.value] === null)) {
      console.warn("Invalid item passed to handleDropdownChange:", item);
      return;
    }

    if (props?.placeHolderItem) {
      if (item) {
        if (props?.placeHolderItem[props?.value] === item[props?.value]) {
          setSelectedItem(props?.placeHolderItem);
        } else {
          setSelectedItem(item);
        }
      } else {
        setSelectedItem(props?.placeHolderItem);
      }

    } else {
      setSelectedItem(item);
    }

    if (item && typeof props?.onDropDownChange === "function" && item[props?.value] !== props?.defaultValue) {
      props?.onDropDownChange(item);
    }
    resetSerchBox();
  };

  const resetSerchBox = () => {
    setFilterData(data);
    setInputValue("");
  };


  const handleDelete = (item) => {
    confirmAlert({
      title:
        "Are you sure you want to delete the Asset Type?",
      message: "",
      buttons: [
        {
          label: "No",
          onClick: () => { },
        },
        {
          label: "Yes",
          onClick: () => {
            deleteSubType(item);
          },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
      overlayClassName: "rooms-alert",
    });
    setEditDropdown(0)
  }

  const deleteSubType = (item) => {
    let id = item.assetTypeId
    // if(item.assetTypeName === this.state.subType)
    //   {
    //     item.subTypeName = "Select Subtype";
    //     item.subTypeID = 0
    //     item.deleted = true; 
    //     this.setState({subType : "" })
    //     this.handleDropdownChange(item)
    //   }
    Facility.DeleteAssetType(id)
      .then(async (result: any | null) => {
        let successToastMessage = "";
        if (result != null && result.messageCode === "Success") {
          toast.success("Subtype deleted sucessfully", {
            position: toast.POSITION.BOTTOM_RIGHT
          });
          // this.getCASubTypes(this.props.row);
          // if(this.state.subType === ""){
          //   this.props.handleCASave();
          // }
          setEditDropdown(0)
        } else {
          setAddSubtypeDropdown(false)
          toast.error("Not Deleted", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setEditDropdown(0)
        }
      })
      .catch((err: any) => {
        Utils.toastError(
          "Subtype already exist",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          }
        )
      });
  }


  const ddlSelectModal = (eventKey: any) => {
    setPlaceholder(eventKey);
  };

  const onTabKeyDown = (e) => {
    e.preventDefault();
    if (toggleRef.current.ariaExpanded === "false" && e?.keyCode === 9) {
      toggleRef.current.click();
      hideRenameDelete()
      setTimeout(() => {
        $(`#ddlSpecailSearchText`)?.focus();
      }, 100);
    }
  };

  const onFocusInput = (eventKey: any) => {
    const { onFocus = () => { } } = props
    onFocus()
    resetSerchBox();
    hideRenameDelete()
    // setTimeout(() => {
    //   inputElement?.current?.focus();
    // }, 100); 
  };

  const { label, value, showBlueBg, tabIndex, style, isIcon, onBlur = (e: any) => { } } = props;

  const onSubTypeAddClick = () => {
    setAddSubtypeDropdown(true);
  }

  const hideAddType = () => {
    setAddSubtypeDropdown(false);
  }

  const handleSaveNewSubType = () => {
    // debugger;
    if (!newSubType || newSubType.trim() === "") {
      toast.error("Asset Type is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "CommonArea",
      });
      return;
    }
    let request = {} as IAddAssetType;
    request.assetTypeName = newSubType;
    EntityManagementService.AddAssetType(request)
      .then(async (result: any) => {
        let successToastMessage = "";
        if (result != null && result.message === "Success") {
          const addedSubType = {
            assetTypeName: result?.result?.assetTypeName,
            assetTypeId: result?.result?.assetTypeId
          };
          if (props?.updateAssetTypesList) {
            props?.updateAssetTypesList(addedSubType);
          }

          setFilterData((prevData) => {
            const updatedData = [addedSubType, ...prevData]
            return updatedData;
          });
          if (props?.onAddAssetType) {
            props?.onAddAssetType(result.result.assetTypeId);
          }
          // forceRefreshFromChild()
          // if (props.forceRefresh) {
          //   console.log('force refresh', props.forceRefresh)
          //   props.forceRefresh();
          // }
          // props?.onAddAssetType(result.result.assetTypeId)
          if (props?.getAssetTypes) {
            props?.getAssetTypes();
          }
          toast.success("Asset Type added sucessfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          });
          setnewSubType('')
          if (result?.message === "Success") {
            if (props?.getAssetTypes) {
              props?.getAssetTypes();
            }
          }
          setAddSubtypeDropdown(false);

          //subType: addedSubType.subTypeName, 
          //addSubtypeDropdown: false, 
          //newSubType: "", 
          //}) , () => {
          handleDropdownChange(addedSubType);
          //});
        } else {
          setAddSubtypeDropdown(false);
          toast.error("Asset type already exist", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          });
          console.log('===Error')
        }
        //resolve();
      })
      .catch((err: any) => {
        Utils.toastError(
          "Asset Type already exist",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          }
        );
        setnewSubType('')
        console.log("===Error1", err)
        //reject();
      });

  }
  const handleSaveUpdateAssetType = (id: number) => {
    let request: IAddAssetType = {
      assetTypeId: id,
      assetTypeName: updatedAssetName.trim().replace(/\s+/g, ' '),
    };

    if (request.assetTypeName === "") {
      toast.error("Asset Type is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    Facility.UpdateAssetType(request)
      .then(async (result: any | null) => {
        if (result != null && result.message === "Success") {
          const addedAssetType = {
            assetTypeName: result.result.assetTypeName,
            assetTypeId: result.result.assetTypeId,
            isUpdateTypeName: true
          };
          setPlaceholder(addedAssetType.assetTypeName)
          setAddSubtypeDropdown(false);
          setEditDropdown(0);
          setUpdatedAssetName(addedAssetType.assetTypeName);
          setFilterData((prevData) => [...(prevData || []), addedAssetType]);
          if (props?.getAssetTypes) {
            props?.getAssetTypes();
          }
          toast.success("Asset Type updated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          handleDropdownChange(addedAssetType);
        } else {
          setAddSubtypeDropdown(false);
          setEditDropdown(0);
          toast.error("Subtype already exists", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        }
        setUpdteSubtypeDropdown(0)
      })
      .catch((err: any) => {
        setUpdteSubtypeDropdown(0)
        setAddSubtypeDropdown(false);
        setEditDropdown(0);
        console.error("Error occurred:", err);
        Utils.toastError("An error occurred while updating the Asset Type", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };



  const hideRenameBox = () => {
    setUpdteSubtypeDropdown(0)
    handleDropdownSearch({ target: { value: '' } })
  }

  const hideRenameDelete = () => {
    $(".edit-dropdown").hide();
    setEditDropdown(0);
  }

  return (
    <>
      <Dropdown
        style={style}
        tabIndex={tabIndex}
        className="single-select"
        onSelect={ddlSelectModal}
        onKeyUp={(e) => onTabKeyDown(e)}
        onBlur={onBlur}
        onClick={onFocusInput}>

        <Dropdown.Toggle ref={toggleRef} id={`Modal-ddl${tabIndex}`} className={`${showBlueBg ? "selected-blue-bg" : ""} ${isIcon && selectedItem[value] <= 0 && "icon-add"}`} disabled={props.disabled}
        >
        <div className={selectedItem?.posStatus == "InActive" ? "show-flex" : ""}>
          {
            isIcon && selectedItem[value] <= 0 && <span className="search-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                <path d="M5.33333 11.4308C6.51665 11.4306 7.66587 11.0344 8.598 10.3055L11.5287 13.2362L12.4713 12.2935L9.54067 9.36283C10.27 8.4306 10.6664 7.28112 10.6667 6.09749C10.6667 3.15683 8.274 0.76416 5.33333 0.76416C2.39267 0.76416 0 3.15683 0 6.09749C0 9.03816 2.39267 11.4308 5.33333 11.4308ZM5.33333 2.09749C7.53933 2.09749 9.33333 3.89149 9.33333 6.09749C9.33333 8.30349 7.53933 10.0975 5.33333 10.0975C3.12733 10.0975 1.33333 8.30349 1.33333 6.09749C1.33333 3.89149 3.12733 2.09749 5.33333 2.09749Z" fill="#84888C" />
              </svg>
            </span>
          }
          <div className="selected-value"><EllipsisWithTooltip placement="bottom">
            {selectedItem &&
              <span
                className={selectedItem[value] <= 0 ? "placeholder-grey" : "placeholder-black"}
                style={{
                  width: "95%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  color: props.defaultTextColor && selectedItem[value] === 0 ? "gray" : "black"
                }}
              >
                {selectedItem[label]}
              </span>
            }
          </EllipsisWithTooltip>
          </div>
          {selectedItem?.posStatus == "InActive" ? <span className="badge badge-deactivated">Deactivated</span> : <></>}
        </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          ref={dropdownMenuRef}
        >
          {props?.isSearchRequired && !addSubtypeDropdown &&
            <div className="search-sec">
              <input
                id="ddlSpecailSearchText"
                type="text"
                className="form-control"
                onChange={handleDropdownSearch}
                placeholder={placeHolder}
                // autoComplete ={"ddlSpecailSearchText" + placeHolder}
                autoComplete="off"
                value={inputValue}
                ref={inputElement}
              />
            </div>
          }
          {filterData?.length > 0 && !addSubtypeDropdown && (
            <div className="list-area">
              <div className="menu" onWheel={() => hideRenameDelete()}>
                {filterData?.map((item: any, idx: any) => (
                  <>
                    <div className="list-item">

                      <Dropdown.Item onClick={() => handleDropdownChange(item)}
                        // className={`${item?.disabled ? "d-flex align-items-center disabled" : "d-flex align-items-center"}`}
                        className={`d-flex align-items-center ${item?.disabled ? "disabled" : ""} ${item?.posStatus === "InActive" ? "justify-content-between" : ""}`}
                        disabled={item?.disabled} onWheel={() => hoverOutEllipsis()}>
                        <div className="type-name"
                        style={{maxWidth: item?.posStatus == "InActive" ? "75%" : "auto"}}
                        ><EllipsisWithTooltip placement="top">{item[label]}</EllipsisWithTooltip></div>
                        {item?.posStatus == "InActive" ? <span className="badge ml-2">Deactivated</span> : <></>}
                        {item.isLowSecurity == 1 && <div className={"ml-auto badge color-blue"}>Low Security</div>}
                        {(props?.isAsset && item?.createdBy !== 0) && (
                          <button onClick={(e) => showDropdown(e, item.assetTypeId, item)}>
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path></svg>
                          </button>
                        )}
                        {editDropdown === item.assetTypeId && props?.isAsset &&
                          <div className="edit-dropdown"
                            style={{
                              position: "absolute",
                              top: (userClickPosition) + "px"
                            }}
                          >
                            <div className="edit-menu"

                            >
                              <div className="dropdown-item">
                                <Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleRename(item.assetTypeId);
                                  }}
                                >
                                  Rename
                                </Button>
                              </div>
                              <div className="dropdown-item">
                                <Button className="delete-btn" style={{ display: 'none' }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDelete(item);
                                  }}
                                >
                                  Delete
                                </Button>
                              </div>
                            </div>
                          </div>
                        }
                      </Dropdown.Item>
                    </div>
                  </>
                ))}
              </div>
            </div>
          )}
          {filterData?.length === 0 && !addSubtypeDropdown && (
            <div className="no-data-found text-center p-2 text-muted">
              No data found
            </div>
          )}
          {props.placeHolder === "Select Asset Type" && !addSubtypeDropdown && <Button className="add-asset-type" onClick={onSubTypeAddClick}>Add Asset Type</Button>}
          {
            addSubtypeDropdown &&
            <div className="edit-dashboard-dropdown">
              <div className="d-flex align-items-center dropdown-header">
                <button
                  onClick={hideAddType}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                    <path d="M5.49961 0.5875C5.17461 0.2625 4.64961 0.2625 4.32461 0.5875L0.499609 4.4125C0.174609 4.7375 0.174609 5.2625 0.499609 5.5875L4.32461 9.4125C4.64961 9.7375 5.17461 9.7375 5.49961 9.4125C5.82461 9.0875 5.82461 8.5625 5.49961 8.2375L2.26628 4.99583L5.49961 1.7625C5.82461 1.4375 5.81628 0.904167 5.49961 0.5875Z" fill="#2CAF92" />
                  </svg>
                </button>
                <h4>Add Type</h4>
              </div>
              <div>
                <div className="dropdown-body">
                  <Form>
                    <Form.Group controlId="subtype">
                      <Form.Label>{props.placeHolder === "Select Asset Type" ? '' : 'Label'}</Form.Label>
                      <div>
                        <Form.Control
                          type="text"
                          placeholder="Enter value"
                          value={newSubType}
                          onChange={(e) => {
                            setnewSubType(e.target.value)
                          }}
                          autoComplete="off"
                        />
                      </div>
                    </Form.Group>
                  </Form>
                </div>
                <div className="d-flex justify-content-end footer">
                  <Button variant="outline"
                    onClick={hideAddType}
                    tabIndex={3}>
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSaveNewSubType}
                    className="ms-2" tabIndex={4}>
                    Save
                  </Button>
                </div>
              </div>
            </div>
          }
          {filterData.map((item: any) => (
            updateSubtypeDropdown === item.assetTypeId && (
              <OutsideClickHandler onOutsideClick={() => setUpdteSubtypeDropdown(0)}>
                <div className="edit-dashboard-dropdown rename-subtype">
                  <div className="d-flex align-items-center dropdown-header">
                    <button
                      onClick={hideRenameBox}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                        <path d="M5.49961 0.5875C5.17461 0.2625 4.64961 0.2625 4.32461 0.5875L0.499609 4.4125C0.174609 4.7375 0.174609 5.2625 0.499609 5.5875L4.32461 9.4125C4.64961 9.7375 5.17461 9.7375 5.49961 9.4125C5.82461 9.0875 5.82461 8.5625 5.49961 8.2375L2.26628 4.99583L5.49961 1.7625C5.82461 1.4375 5.81628 0.904167 5.49961 0.5875Z" fill="#2CAF92" />
                      </svg>
                    </button>
                    <h4>Rename Asset Type</h4>
                  </div>
                  <div>
                    <div className="dropdown-body">
                      <Form>
                        <Form.Group controlId="subtype">
                          <div>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 100, hide: 200 }}
                              overlay={
                                <Tooltip id={"assetName"} className={updatedAssetName?.length > 38 ? "d-block" : "d-none"}>
                                  {updatedAssetName}
                                </Tooltip>
                              }>
                              <Form.Control
                                type="text"
                                placeholder="Enter value"
                                value={updatedAssetName}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setUpdatedAssetName(e.target.value)
                                }}
                                autoComplete="off"
                                maxLength={100}
                              />
                            </OverlayTrigger>
                          </div>
                        </Form.Group>
                      </Form>
                    </div>
                    <div className="d-flex justify-content-end footer">
                      <Button variant="outline"
                        onClick={hideRenameBox}
                        tabIndex={3}>
                        Cancel
                      </Button>
                      <Button
                        onClick={(e) => { handleSaveUpdateAssetType(item.assetTypeId) }}
                        className="ms-2" tabIndex={4}
                      // disabled = {this.state.saved}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </OutsideClickHandler>
            )))
          }
        </Dropdown.Menu>
      </Dropdown>

    </>
  );
};
DropDownList.defaultProps = {
  isSearchRequired: true,
  showBlueBg: false,
  shouldToggle: false
};